import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Modal, { ModalButton } from '../../../ui/Modal';

const ModalDeliveryOrdersCanceled = ({ onClose, onConfirm }) => (
  <Modal
    isOpen={true}
    onClose={onClose}
    title="Отменить заказы"
    subtitle="Выбранные заказы будут переведены в статус «Отменён»."
    size="sm"
    footer={
      <>
        <ModalButton variant="ghost" onClick={onClose}>Не отменять</ModalButton>
        <ModalButton variant="danger" onClick={onConfirm}>
          <CancelOutlinedIcon sx={{ fontSize: 18 }} />
          Отменить
        </ModalButton>
      </>
    }
  >
    <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: '#6F6259' }}>
      Действие нельзя отменить. Клиенты получат уведомление о том, что заказы отменены.
    </p>
  </Modal>
);

export default ModalDeliveryOrdersCanceled;
